import { Icon } from '../../../../core/Icon';
import { Text, VStack, useBreakpointValue } from '@gluestack-ui/themed';
import { DimensionValue } from 'react-native';
import { StatusCardProps } from './types';
import { IconNames } from '@repo/core/components/core/Icon/types';

export const StatusCard = ({
  icon = 'file-circle-check',
  subtitle = '',
  subtitleMaxWidth = '$64',
  title = '',
  iconColor
}: StatusCardProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <VStack
      alignItems="center"
      justifyContent="center"
      gap={isMobile ? '$4' : '$6'}
    >
      <VStack alignItems="center" justifyContent="center">
        <Icon
          name={icon as IconNames}
          color={iconColor}
          size={isMobile ? 48 : 64}
        />
      </VStack>
      <Text
        size={isMobile ? 'lg' : '2xl'}
        fontWeight={600}
        textAlign="center"
        color="$textLight900"
      >
        {title}
      </Text>
      <Text
        size={isMobile ? 'sm' : 'lg'}
        textAlign="center"
        fontWeight={400}
        color="$textLight900"
        maxWidth={subtitleMaxWidth as DimensionValue}
      >
        {subtitle}
      </Text>
    </VStack>
  );
};
